import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Location, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiBillingRates extends Layout {
    buttonEditMaxTotal: Button;
    buttonEditTargetTotal: Button;
    buttonEstimateFuelSurcharge: Button;
    buttonExpandCharges: Button;
    buttonExpandDetails: Button;
    buttonExpandTaxes: Button;
    buttonRate: Button;
    checkboxLockMiles: Checkbox;
    chevronSpacer2: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelFreightCharge: Label;
    labelRatingDetails: Label;
    labelTaxCharge: Label;
    labelTaxesHeader: Label;
    labelTotalCharge: Label;
    layoutMovementRates: MovementCarrierPay;
    panelAllocation: Panel;
    panelChevron2: Panel;
    panelChevron: Panel;
    panelExciseTaxTotal: Panel;
    panelFreightCharge: Panel;
    panelOrderCarrierPay: Panel;
    panelOrderMaxPay: Panel;
    panelOrderRates: Panel;
    panelOrderTargetPay: Panel;
    panelOtherChargeTable: Panel;
    panelOtherCharges: Panel;
    panelOtherChargesHeader2: Panel;
    panelOtherChargesHeader: Panel;
    panelRateTotals: Panel;
    panelRatesHeader: Panel;
    panelRatingDetails: Panel;
    panelRatingDetailsHeader2: Panel;
    panelRatingDetailsHeader: Panel;
    panelRatingDetailsTable: Panel;
    panelReviewAdditionalCharges: Panel;
    panelReviewFreightCharge: Panel;
    panelReviewTotalCharges: Panel;
    panelSwitchSpacer: Panel;
    panelTaxTable: Panel;
    panelTaxes: Panel;
    panelTaxesHeader: Panel;
    panelTotalWithTaxes: Panel;
    sourceDistanceAlert: DataSource;
    sourceEdiBillingDetail: DataSource;
    sourceEdiDriverextrapay: DataSource;
    sourceExcisetaxChargeEdi: DataSource;
    sourceOrders: DataSource;
    sourceOtherChargeEdi: DataSource;
    sourceRatingDetails: DataSource;
    sourceRatingDetailsSummary: DataSource;
    spacerRatingDetailsHeader: HorizontalSpacer;
    switchByFreightItem: Switch;
    tableEdiDriverExtraPay: Table;
    tableOtherCharges: Table;
    tableRevPerFgi: Table;
    tableRevSummary: Table;
    tableTax: Table;
    textboxBillDistance: Textbox;
    textboxCollectionMethod: Textbox;
    textboxCtrlParty: Location;
    textboxCurrencyType: Textbox;
    textboxExcisetaxTotal: Textbox;
    textboxFreightCharge2: Textbox;
    textboxFreightCharge: Textbox;
    textboxMaxMargin: Textbox;
    textboxMaxMarginPercent: Textbox;
    textboxMaxPay: Textbox;
    textboxOtherchargetotal: Textbox;
    textboxPayGross: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateMinWeight: Textbox;
    textboxRateType: Textbox;
    textboxRateUnitDesc: Textbox;
    textboxRateUnits: Textbox;
    textboxSegAllocCode: Textbox;
    textboxTargetMarginAmount: Textbox;
    textboxTargetMarginPercent: Textbox;
    textboxTargetPay: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalWithTax: Textbox;
    textboxWeight: Textbox;
}
